'use strict';
import isArray from 'lodash/isArray';
import isNumber from 'lodash/isNumber';

/**
 * @typedef {Object} LatLong
 * @property {Number} lat
 * @property {Number} lon
 */

/**
 * Extract lat, long pair from GeoJSON object.
 * @param {GeoJSON} geo
 * @return {?LatLong}
 */
export function getLatLong(geo) {
  if (geo && geo.geometry && geo.geometry.coordinates && isNumber(geo.geometry.coordinates[0]) && isNumber(geo.geometry.coordinates[1])) {
    return {
      lat: geo.geometry.coordinates[1],
      lon: geo.geometry.coordinates[0],
    }
  } else {
    return null;
  }
}

/**
 * @param {Number} coordinate
 * @returns {String}
 * @source https://stackoverflow.com/a/37893239/1800748
 */
export function toDegreesMinutesAndSeconds(coordinate) {
  const absolute = Math.abs(coordinate);
  const degrees = Math.floor(absolute);
  const minutesNotTruncated = (absolute - degrees) * 60;
  const minutes = Math.floor(minutesNotTruncated);
  const seconds = ((minutesNotTruncated - minutes) * 60).toFixed(1);

  return `${degrees}\xB0 ${minutes}' ${seconds}"`;
}

/**
 * @param {Number} lat
 * @param {Number} lng
 * @returns {String}
 * @source https://stackoverflow.com/a/37893239/1800748
 */
export function convertDMS(lat, lng) {
  const latitude = toDegreesMinutesAndSeconds(lat);
  const latitudeCardinal = Math.sign(lat) >= 0 ? 'N' : 'S';

  const longitude = toDegreesMinutesAndSeconds(lng);
  const longitudeCardinal = Math.sign(lng) >= 0 ? 'E' : 'W';

  return `${latitude} ${latitudeCardinal}, ${longitude} ${longitudeCardinal}`;
}

/**
 * Validates that an input Lat, Long pair are valid coordinates
 * @param {Array} coordinates - Latitude, Longitude
 * @returns {boolean}
 */
export function validateCoordinates(coordinates) {
  if (!isArray(coordinates)) return false;
  return validateLatLng(coordinates[0], coordinates[1]);

  if (!isNumber(coordinates[0]) || !isNumber(coordinates[1])) return false;
  return Math.abs(coordinates[0]) <= 90 && Math.abs(coordinates[1]) <= 180;
}

/**
 * Validates that an input Lat, Long pair are valid coordinates
 * @param lat
 * @param lon
 * @returns {boolean}
 */
function validateLatLng(lat, lon) {
  if (!isNumber(lat) || !isNumber(lon)) return false;
  return Math.abs(lat) <= 90 && Math.abs(lon) <= 180;
}

/**
 *
 * @param {LatLong} latLong
 * @return {?Array<Number>}
 */
export function latLongToGeoJsonCoordinates(latLong) {
  if (!latLong) {
    return null;
  } else {
    return [latLong.lon, latLong.lat];
  }
}

/**
 * Returns a simple point GeoJSON object.
 * @param lat
 * @param lon
 * @returns {GeoJSON}
 */
export function createGeoJsonPoint(lat = null, lon = null) {
  return {
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: validateLatLng(lat, lon) ? [lon, lat] : null,
    },
    properties: {
      address: '',
    }
  };
}



// WEBPACK FOOTER //
// ./src/js/core-utilities/geo/utils.js